/**
 * Data source configuration management
 */

import { DataSourceConfig } from './types';
import { logger } from '../logger';

// Log the environment variable value for debugging when verbose logging enabled
logger.debug('🔧 VITE_USE_MOCK_DATA environment variable:', import.meta.env.VITE_USE_MOCK_DATA);
logger.debug('🔧 Parsed as boolean (=== "true"):', import.meta.env.VITE_USE_MOCK_DATA === 'true');

const DEFAULT_CONFIG: DataSourceConfig = {
  source: import.meta.env.VITE_USE_MOCK_DATA === 'true' ? 'mock' : 'live',
  mockDelay: parseInt(import.meta.env.VITE_MOCK_DELAY || '1000'),
  logMockCalls: import.meta.env.VITE_LOG_MOCK_CALLS === 'true' || import.meta.env.DEV
};

let currentConfig = { ...DEFAULT_CONFIG };

export function getConfig(): DataSourceConfig {
  return { ...currentConfig };
}

export function updateConfig(config: Partial<DataSourceConfig>): void {
  currentConfig = { ...currentConfig, ...config };
}

export function isUsingMockData(): boolean {
  return currentConfig.source === 'mock';
}

export function resetConfig(): void {
  currentConfig = { ...DEFAULT_CONFIG };
}
